import { useNavigate } from 'react-router-dom';

import Button from 'components/Button';
import Typography from 'components/Typography';

import {
  NotFoundContainer,
  NotFoundContent,
  NotFoundIcon,
  NotFoundTitle,
  NotFoundButton,
} from './NotFound.styled.ts';

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <NotFoundContainer>
      <NotFoundContent>
        <NotFoundIcon>🏠</NotFoundIcon>

        <NotFoundTitle>
          <Typography
            type="Title"
            size="large"
            style="semibold"
            color="#5F522D"
          >
            404
          </Typography>
          <Typography type="Title" size="small" style="semibold">
            Página no encontrada
          </Typography>
          <Typography type="Body" size="small" style="normal" color="#5C5C5C">
            Lo sentimos, la página que buscas no existe o ha sido movida.
          </Typography>
        </NotFoundTitle>

        <NotFoundButton>
          <Button variant="primary" onClick={handleGoHome}>
            Volver al inicio
          </Button>
        </NotFoundButton>
      </NotFoundContent>
    </NotFoundContainer>
  );
};

export default NotFound;
